import React from "react";
import ReactDOM from "react-dom";
import _ from "_";
import { Modal } from "@ucloud-fe/react-components";
import { Button, Input, Icon } from '@ucloud-fe/react-components';
import { isMobile } from "../../service/deviceDetectService";
import localeService from "../../service/localeService";
import Notice from "./Notice.jsx";

//获取手机验证码的弹窗。

class CodeModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}
  render() {
    const {
      visible, //控制是否显示
      verifyPictureCodeChange, //验证码输入监听
      _verifyUrl, //验证码图片
      onCancel, //取消函数
      inputValue, //验证码输入值 受控
      sendVerifyCode, //验证码 ok点击函数
      pictureCodeErrorMsg, // 报错信息
      changeVerifyPictureCode, //刷新验证码图片
      phoneNum //手机号
    } = this.props;
    return (
      <Modal
      visible={visible}
      onClose={onCancel}
      maskClosable={isMobile() ? true : false}
      style={isMobile() ? { width: "100%", top: 0 } : { width: 440 }} 
      title={<span className="u-font-wt-bold">{localeService.getTranslate("CODEMODAL2")}</span>}
      footer={
        <div>{isMobile() ? null : (
          <Button
            size="lg"
            styleType="border"
            className="u-mr12"
            onClick={() => {
              onCancel();
            }}
          >
            {localeService.getTranslate("CANCEL")}
          </Button>
        )}
        {isMobile() ? (
          <div
            className="
          app-form-item register-form-wrapper u-p0 u-m0"
          >
            <Button
              size="lg"
              styleType="primary"
              onClick={() => {
                sendVerifyCode();
              }}
              disabled={!inputValue}
            >
              {localeService.getTranslate("OK")}
            </Button>
          </div>
        ) : (
          <Button
            size="lg"
            styleType="primary"
            onClick={() => {
              sendVerifyCode();
            }}
            disabled={!inputValue}
          >
            {localeService.getTranslate("OK")}
          </Button>
        )}</div>
      }
      >
        {pictureCodeErrorMsg && (
          <Notice
            className="register-notice"
            styleType="error"
            message={pictureCodeErrorMsg}
            style={{ marginBottom: 24 }}
          />
        )}
       { phoneNum&&<div>
          {localeService.getTranslate("CODEMODAL1")}
          {phoneNum}
          {localeService.getTranslate("CODEMODAL3")}
        </div>}
        <div className="register-form-wrapper">
          <div className="u-dib app-form-item" style={isMobile() ? {} : {marginTop: 0 }}>
            <Input
              value={inputValue}
              onChange={e => verifyPictureCodeChange(e.target.value)}
              style={isMobile() ? {} : { width: "238px", height: "60px"}}
              prefix={<Icon type="safe2"></Icon>}
              onKeyDown={e => {
                if (inputValue&&e.keyCode && e.keyCode == "13") {
                  return sendVerifyCode();
                }
              }}
            />
          </div>
          <div
            onClick={() => changeVerifyPictureCode()}
            className="verify-img-wrapper u-dib u-vt"
          >
            <img className="u-verify-code" src={_verifyUrl} />
          </div>
        </div>
      </Modal>
    );
  }
}
export default CodeModal;



// WEBPACK FOOTER //
// src/pc/components/CodeModal.jsx